all_periods = require 'models/transaction_periods.coffee'
all_periods = _.flatten(_.map all_periods, 'periods')

module.exports = class PlannedGenerator
  constructor: (tr, user, change_future_trs) ->
    @tr         = tr
    @user       = user
    @start_date = tr.date
    @period     = tr.planned_repeat_days
    @end_mode   = tr.planned_repeat_end
    @end_date   = tr.planned_repeat_end_date || hm_date.addMonths_f(new Date, 1000 * 12)

    @transaction_period = _.find(all_periods, { days: @period })
    @interval_name = @transaction_period?.name_ru
    @end_date      = _.min [hm_date.addMonths_f(new Date, 12), @end_date]
    @end_date = hm_date.addMonths_f(new Date, 12) if @end_mode != 'date'

    @future_deleted_transactions_ids = if change_future_trs then @deleteFutureTransaction() else []
    @future_common_transactions      = if change_future_trs then @createFutureTransactions() else []

  deleteFutureTransaction: ->
    return [] unless @tr.common_id
    trs = @user.transactions.filter (t) =>
      t.common_id == @tr.common_id and t.date > @tr.date and t.id != @tr.id and !_.isNumber(t.real_amount)
    _.map trs, 'id'

  createFutureTransactions: ->
    return [] unless @period > 0
    date_tmp = @start_date
    new_dates = []

    while date_tmp < @end_date

      date_tmp = hm_date.format @transaction_period.getNextDate(date_tmp)
      break if date_tmp > @end_date
      week_day = hm_date.format(date_tmp, 'd')
      continue if @interval_name == 'По будням' && (week_day == '0' || week_day == '6')
      continue if @interval_name == 'По выходным' && week_day != '0' && week_day != '6'
      continue if @interval_name == '2 через 2 дня' && hm_date.differenceInDays(date_tmp, @start_date) % 4 > 1
      new_dates.push date_tmp

    return [] if new_dates.length == 0
    _.map new_dates, (new_date) =>
      new_tr             = _.clone @tr
      new_tr.id          = undefined
      new_tr.date        = new_date
      new_tr.real_amount = undefined
      new_tr
